import { render, staticRenderFns } from "./MediaRenderer.vue?vue&type=template&id=67168317"
import script from "./MediaRenderer.vue?vue&type=script&lang=js"
export * from "./MediaRenderer.vue?vue&type=script&lang=js"
import style0 from "./MediaRenderer.vue?vue&type=style&index=0&id=67168317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports